import { render, staticRenderFns } from "./Comp11t3.vue?vue&type=template&id=5831be50&scoped=true&"
import script from "./Comp11t3.vue?vue&type=script&lang=js&"
export * from "./Comp11t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp11t3.vue?vue&type=style&index=0&id=5831be50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5831be50",
  null
  
)

export default component.exports